import styled from 'styled-components';
import colors from '../../../../utils/colors';

const { colorWhite } = colors;

export const Box = styled.div`
	background-color: ${colorWhite};
	border-radius: 2.5rem;
	padding: 3rem 4rem;
`;

export const Form = styled.form`
	width: 100%;
	max-width: 35rem;
	// min-width: 30rem;
`;

export const ForgotPassword = styled.div`
	margin-top: -1.2rem;
	display: ${(props) => props.display1 && props.display1};

	&:hover {
		text-decoration: underline;
	}

	@media screen and (max-width: 500px) {
		display: ${(props) => props.display2 && props.display2};
		margin: ${(props) => props.margin && props.margin};
	}
	a {
		text-align: center;
		font-size: 1.4rem;
		color: #000;
		font-weight: 500;
	}
`;
